// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1686":"95ed74b218564ee0","3008":"243fd215fec74c27"}[chunkId] + ".css";
};